import Model, { AsyncBelongsTo, attr, belongsTo } from '@ember-data/model';
import { dependentKeyCompat } from '@ember/object/compat';
import config from 'admin-panel/config/environment';

import type HotelModel from 'admin-panel/models/hotel';

export default class PdfModel extends Model {
  @belongsTo('hotel')
  declare hotel: AsyncBelongsTo<HotelModel>;

  @attr
  declare name: string;

  @attr
  declare pdfUrl: string | null;

  @attr
  declare versions: {
    preview?: string | null;
    originals?: unknown[];
  } | null;

  @dependentKeyCompat
  get insertablePdfUrl() {
    const pdfUrl = this.pdfUrl?.trim();

    if (!pdfUrl) {
      return '';
    }

    try {
      const url = new URL(pdfUrl);

      return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
    } catch {
      return '';
    }
  }

  @dependentKeyCompat
  get pageImageUrls() {
    return (this.versions?.originals ?? []).flatMap((path) => {
      if (typeof path !== 'string') {
        return [];
      }

      const trimmedPath = path.trim();

      if (!trimmedPath) {
        return [];
      }

      try {
        const url = new URL(trimmedPath, config.api.host);

        return ['http:', 'https:'].includes(url.protocol) ? [url.href] : [];
      } catch {
        return [];
      }
    });
  }

  @dependentKeyCompat
  get firstPageUrl() {
    return this.pageImageUrls[0] ?? '';
  }

  @dependentKeyCompat
  get isInsertable() {
    const originals = this.versions?.originals;

    return Boolean(
      this.insertablePdfUrl &&
        originals?.length &&
        this.pageImageUrls.length === originals.length
    );
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    pdf: PdfModel;
  }
}
